import { IconCloudUpload, IconLoader2 } from '@tabler/icons-react'
import { useState } from 'react'
import { MonthCode } from 'src/API/rest.forecast_regionwise'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'
import { DatePickerStandard, InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RefMonthComponent } from './component.refMonth'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { useRestAPI } from 'src/API/axiosAPI'
import { useStylewiseForcast } from 'src/API/rest.stylewiseForcast'
import { ProgressFullScreen } from 'src/components/progressLoading'
import { toast } from 'src/shadcn/ui/use-toast'
import { Input } from 'src/shadcn/ui/input'
import { format, getDaysInMonth, parse } from 'date-fns'
import DatePicker from 'react-datepicker'
import { useSecondarySalesData } from 'src/API/rest.secSalesData'
import { ModalValidationError } from './component.validationErrorModal'
import { usePrimarySalesData } from 'src/API/rest.primarySalesData'
interface InvalidData {
    invalid_products: string[];
    invalid_skus: string[];
    invalid_distributors: string[];
    invalid_product_distributor_mappings: string[];
}

type MonthType = {
    month: string;
    value: string;
}

function validateDateRange(startDateStr: string, endDateStr: string): true | string {
    // Convert strings to Date objects
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);


    if (startDate.getFullYear() !== endDate.getFullYear() || startDate.getMonth() !== endDate.getMonth()) {
        return "Not in the same month";
    }

    if (startDate > endDate) {
        return "Start date is greater";
    }

    return true;
}

export default function PrimaryDataUpload() {
    const [isOpen, setIsOpen] = useState(false)
    const [isDownloadingTemplate, setisDownloadingTemplate] = useState(false);
    const [startDate, setstartDate] = useState<string | null>(null)
    const [endDate, setendDate] = useState<string | null>(null)
    const [year, setYear] = useState<string | null>(null)
    const [seletedFile, setSelectedFile] = useState<File | null>(null)
    const [validationErrors, setValidationErrors] = useState<InvalidData | null>(

        null
    )
    const api = useRestAPI()

    const {
        downloadPrimarySalesTemplate
    } = usePrimarySalesData({})

    const months = [
        { key: "01", value: "January" },
        { key: "02", value: "February" },
        { key: "03", value: "March" },
        { key: "04", value: "April" },
        { key: "05", value: "May" },
        { key: "06", value: "June" },
        { key: "07", value: "July" },
        { key: "08", value: "August" },
        { key: "09", value: "September" },
        { key: "10", value: "October" },
        { key: "11", value: "November" },
        { key: "12", value: "December" }
    ];

        const handleDownloadTemplate = async () => {
        setisDownloadingTemplate(true);
        await downloadPrimarySalesTemplate()
        setisDownloadingTemplate(false);
    };


    const {
        validatePrimarySalesDataExcel,
        isValidatingPrimarySalesDataExcel,
        isValidatePrimarySalesDataExcelError,
        validateProgress,
        uploadProgress,
        uploadPrimarySalesDataExcel,
        isUploadingPrimarySalesDataExcel,
    } = usePrimarySalesData({})


    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })

    const {
        states,
        isLoading: isLoadingState,
        isError: isErrorState,
        isFetching: isFetchingState
    } = useStatesAPI({
        trigger: true
    });

    // console.log(startDate,endDate)


    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>

            <ProgressFullScreen
                progress={validateProgress}
                show={isValidatingPrimarySalesDataExcel}
                subTitle='Validating file...'
            />
            <ProgressFullScreen
                progress={uploadProgress}
                show={false}
                subTitle='uploading file...'
            />

            <ModalValidationError
                invalidData={validationErrors || null}
                show={isOpen}
                setShow={setIsOpen}
            />


            {/* Ref Month
            <RefMonthComponent
                forecastMonth={latestCalendarDate?.date || ''}
                isFetchingLatestForecastCalender={isFetchinglatestCalendarDate}
            /> */}
                        <div className=' w-full text-center'>Download Template {isDownloadingTemplate ? <IconLoader2 size={10} className=' inline animate-spin' /> : <span onClick={handleDownloadTemplate} className=' underline text-blue-500 cursor-pointer hover:text-blue-700'>here</span>}</div>

            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-3 '>
                    <TypographyH2>Primary Sales Data Upload</TypographyH2>
                    <div className=' flex gap-2 '>

                        <SelectStandard
                            title='Start Month'
                            placeHolder='Select Month'
                            options={months.map((month) => {
                                return {
                                    label: month.value,
                                    value: month.key
                                }
                            })}
                            onChange={(date) => {
                                if (!date)
                                    setstartDate(null)
                                else
                                    setstartDate(date.target.value)
                            }}
                        />
                        <SelectStandard
                            title='End Month'
                            placeHolder='Select Month'
                            options={months.map((month) => {
                                return {
                                    label: month.value,
                                    value: month.key
                                }
                            })}
                            onChange={(date) => {
                                if (!date)
                                    setendDate(null)
                                else
                                    setendDate(date.target.value)
                            }}
                        />

                        <DatePickerStandard
                            title='Year'
                            className=' border p-2 rounded-md w-16'
                            showYearPicker
                            selected={year ? new Date(year) : null}
                            onChange={(date) => {
                                if (!date)
                                    setYear(null)
                                else
                                    setYear(format(date as Date, 'yyyy-MM-dd'))
                            }}
                            dateFormat="yyyy"
                        />
                        {/* <DatePickerStandard
                            title='End Date'
                            className=' border p-2 rounded-md'
                            selected={endDate ? new Date(endDate) : null}
                            onChange={(date) => {
                                if (!date)
                                    setendDate(null)
                                else
                                    setendDate(format(date as Date, 'yyyy-MM-dd'))
                            }}
                            dateFormat="dd-MMM-yyyy"
                        /> */}

                    </div>
                    <div className=' grow flex items-center  w-min mx-auto mt-8'>
                        <FileInputDragDropStandard
                            // disabled={!startDate || !endDate}

                            onDrop={async (file) => {

                                if (!startDate || !endDate) {
                                    toast({
                                        description: 'Please select start and end date',
                                        title: 'Error'
                                    })
                                    return
                                }
                                // const response1 = validateDateRange(startDate!, endDate!)
                                // if (response1 !== true) {
                                //     toast({
                                //         description: response1,
                                //         title: 'Error'
                                //     })
                                //     return;
                                // }


                                const response = await validatePrimarySalesDataExcel({
                                    file: file!
                                })
                                if (response.success === false) {
                                    toast({
                                        description: response.message
                                    })
                                    setValidationErrors(response.errors || null)
                                    if (response.errors)
                                        setIsOpen(true)
                                } else {
                                    setSelectedFile(file);
                                }
                            }}
                            file={seletedFile}
                            onClear={() => setSelectedFile(null)}
                            accept={{
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                                'application/vnd.ms-excel': ['.xls'],
                                'text/csv': ['.csv']
                            }}
                        />
                    </div>
                    <ButtonIconSquare
                        disabled={seletedFile === null}
                        className=' mx-auto mb-5'
                        icon={false ? <IconLoader2 className='animate-spin' /> : <IconCloudUpload />}
                        onClick={async () => {

                            if (!startDate || !endDate || !year) {
                                toast({
                                    description: 'Please select start and end date',
                                    title: 'Error'
                                })
                                return
                            }

                            console.log(Number(startDate), Number(endDate))

                            if (Number(startDate) > Number(endDate)) {
                                toast({
                                    description: 'Start Date should be less than End Date',
                                    title: 'Error'
                                })
                                return
                            }

                            
                            const yearString = new Date(year).getFullYear().toString()
                            const endDay = getDaysInMonth(new Date(Number(yearString), Number(endDate)-1))
                            const start = `${yearString}-${startDate}-01`
                            const end = `${yearString}-${endDate}-${endDay}`

                            console.log(start, end)

                            

                            const response = await uploadPrimarySalesDataExcel({
                                file: seletedFile!,
                                start_date: start!,
                                end_date: end!
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            } else {
                                toast({
                                    title: 'Success',
                                    description: response.message
                                })
                                setSelectedFile(null)
                            }
                        }}
                        variant='secondary' text='Submit' />
                </div>
            </div>

        </div>
    )
}

